module.exports = __webpack_public_path__ + "static/media/cannonball.276f8658.png";